module.exports = __webpack_public_path__ + "static/media/infoJumbo3.4ea0aae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/exeron/images/infoJumbo3.jpg
// module id = 505
// module chunks = 0